module.exports = __webpack_public_path__ + "static/media/workingmemory-words-9.b0cf3929.mp3";